export const NAMESPACES = {
    AGE_MSG: `The patient's age may present a risk to adherence as patient
                may face challenges such as cognitive decline, mobility
                limitations, or managing complex medication regimens, which could
                hinder their ability to consistently follow their treatment plans.`,
    HEALTH_MSG: `Patient may struggle to understand medication instructions,
                recognize the importance of their treatment plan, or navigate
                healthcare systems effectively.`,
    FINANCIAL_MSG: ` Patient may have difficulty affording medications, attending
                regular appointments, or accessing necessary treatments, which can
                negatively impact their ability to follow their prescribed care
                plan.`,
    CO_MORBITIES_MSG: `Managing multiple health conditions simultaneously can lead to a
                more complicated treatment plan, making it harder for the patient to
                consistently adhere to their prescribed medications and care
                routines.`,
    TECHNOLOGY_MSG: `Limited access to or unfamiliarity with technology
                makes it difficult for the patient to engage with digital health tools, reminders, and
                telemedicine, which can hinder their ability to manage their
                treatment effectively.`,
    SOCIAL_MSG: `Patient indicated they have 0 people in the household. Lack of
                    transportation could hinder access to medication.`,
    ALCOHOL_MSG: `Patient indicated regular alcohol consumption. This may
                    interfere with medication adherence and increase the risk of
                    complications in managing their treatment plan.`,
    PEER_MSG: `Leverage peer support to foster a sense of community,
                      providing individuals with shared experiences and emotional
                      guidance to improve engagement and adherence to care plans.`,
    SOCIAL_WORKER_MSG: `Connect with a social worker to access additional resources,
                      support services, and guidance tailored to your unique
                      needs, enhancing overall well-being and addressing any
                      barriers to achieving your goals.`,
  }
  